import { getToken } from './getToken';

export const actions = {
  getToken,
};
